"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHostedPageResult = exports.isHostedPage = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
const HostedPageSchema = zod_1.z.object({
    expires_at: zod_1.z.number(),
    id: zod_1.z.string(),
    pass_thru_content: zod_1.z.string().optional(),
    state: zod_1.z.string(),
    type: zod_1.z.string(),
    url: zod_1.z.string(),
});
exports.isHostedPage = type_validation_helpers_1.getVerboseTypeValidationFunction(HostedPageSchema);
const HostedPageResultSchema = zod_1.z.object({
    hosted_page: HostedPageSchema,
});
exports.isHostedPageResult = type_validation_helpers_1.getVerboseTypeValidationFunction(HostedPageResultSchema);
//# sourceMappingURL=chargebee_models.js.map